module.exports = __webpack_public_path__ + "static/media/ghost.22df201c.svg";